import React from 'react';
import { Button } from 'react-bootstrap';
import { BsFillChatDotsFill } from 'react-icons/bs';
import '../css/Chat.css';  // Custom styles for the chat component

const ChatButton = ({ handleChatToggle }) => {
  return (
    <Button
      variant="danger"
      className="floating-chat-button"
      onClick={handleChatToggle}
    >
      <BsFillChatDotsFill color="white" size={24} />
    </Button>
  );
};

export default ChatButton;